import { BandChartDataArray } from 'components/chart/data/BandChartDataArray';
import { ChartDataArray } from './ChartDataArray';
import { ChartDataComparisonType } from './ChartDataComparisonType';
import { ChartDataType } from './ChartDataType';
import { ChartValue } from './ChartValue';
import { LegendConfig } from './LegendConfig';
import { TooltipConfig } from './TooltipConfig';
import { XAxisConfig } from './XAxisConfig';
import { YAxisConfig } from './YAxisConfig';

export class ChartConfig {
  data?: ChartDataArray[] = [];

  bandData?: BandChartDataArray = undefined;

  detectionDateMarker?: {
    label: string;
    color?: string;
    focusRingColor?: string;
  };

  highlightLineColor?: string;

  value?: ChartValue = {};

  additionalValue?: ChartValue = {};

  seriesLabels?: string[];

  xAxisConfig: XAxisConfig = {};

  yAxisConfig: YAxisConfig = {};

  legendConfig: LegendConfig = {};

  customTooltip?: TooltipConfig;

  svgClassName?: string;

  public getDataArray(type: ChartDataType, comparisonType?: ChartDataComparisonType): ChartDataArray | undefined {
    return this.data!.find(
      d => d.type === type && (comparisonType ? d.comparisonType === comparisonType : !d.isComparison)
    );
  }

  public getDataArrays(type: ChartDataType, comparisonType?: ChartDataComparisonType): ChartDataArray[] {
    return this.data!.filter(
      d => d.type === type && (comparisonType ? d.comparisonType === comparisonType : !d.isComparison)
    );
  }
}
